import { create } from 'zustand';
import { User } from '../types';
import { auth } from '../lib/firebase/init';
import { signOut } from 'firebase/auth';
import { logger } from '../utils/logger';

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  reset: () => void;
  logout: () => Promise<void>;
}

const initialState = {
  user: null,
  loading: true,
  error: null
};

export const useAuthStore = create<AuthState>((set) => ({
  ...initialState,
  
  setUser: (user) => {
    logger.info('Setting user state', { userId: user?.id });
    set({ user, error: null });
  },
  
  setLoading: (loading) => {
    logger.info('Setting loading state:', loading);
    set({ loading });
  },
  
  setError: (error) => {
    if (error) {
      logger.error('Auth store error:', error);
    }
    set({ error });
  },
  
  clearError: () => set({ error: null }),
  
  reset: () => set(initialState),
  
  logout: async () => {
    try {
      logger.info('Logging out user');
      set({ loading: true });
      await signOut(auth);
      set({ user: null, loading: false, error: null });
      logger.info('Logout successful');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to sign out';
      logger.error('Logout failed:', error);
      set({ error: message, loading: false });
      throw error;
    }
  }
}));